module.exports = __webpack_public_path__ + "img/ic_add_dark_grey.296b51a3.svg";